import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'

import {
    Box,
    Modal,
    ModalContent,
    ModalOverlay,
    ModalBody,
    ModalHeader,
    ModalCloseButton,
    useBreakpointValue
} from '@salesforce/retail-react-app/app/components/shared/ui'

const FooterModal = ({isOpen, onClose, content, styles}) => {
    const [modalHeading, setModalHeading] = useState('')
    const [modalBody, setModalBody] = useState('')

    useEffect(() => {
        if (content) {
            const doc = new DOMParser().parseFromString(content, 'text/html')
            const headingEl = doc.querySelector('div.block-heading__title')
            const heading = headingEl ? headingEl.innerHTML : ''
            if (headingEl) {
                headingEl.remove()
            }

            const body = doc.body.innerHTML

            setModalHeading(heading)
            setModalBody(body)
        }
    }, [content])

    const size = useBreakpointValue({base: 'full', lg: '2xl', xl: '4xl'})

    return (
        <Modal size={size} isOpen={isOpen} onClose={onClose} scrollBehavior="inside" isCentered>
            <ModalOverlay />
            <ModalContent padding={'4px'} marginTop={'0'} borderRadius={'0'}>
                <ModalHeader {...styles.heading}>
                    <Box
                        dangerouslySetInnerHTML={{
                            __html: modalHeading
                        }}
                    ></Box>
                </ModalHeader>
                <ModalCloseButton
                    border={'2px solid #737373'}
                    borderRadius={'50%'}
                    color={'#737373'}
                />
                <ModalBody {...styles.body}>
                    <Box
                        sx={{
                            ['ul']: {
                                margin: '16px 0',
                                padding: '0 0 0 40px'
                            }
                        }}
                        dangerouslySetInnerHTML={{
                            __html: modalBody
                        }}
                    ></Box>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

FooterModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    content: PropTypes.string,
    styles: PropTypes.object
}

export default FooterModal
